import React from 'react';
import { Shield, Zap, BarChart3, Globe, Smartphone, Coins } from 'lucide-react';
import './Trading.css';

const Trading = () => {
  return (
    <div className="trading">
      <section className="trading-hero">
        <div className="container">
          <div className="trading-hero-content">
            <div className="trading-hero-text">
              <h1>Cryptocurrency Trading Platform</h1>
              <p>
                Experience the future of digital asset trading with our cutting-edge platform. 
                Advanced tools, real-time data, and unmatched security for crypto traders.
              </p>
              <a 
                href="https://wa.me/2348095732028?text=Hi%20KENNY%20MILES%20EXCHANGE,%20I%20want%20to%20trade" 
                className="btn btn-secondary" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                Start Trading Now
              </a>
            </div>
            <div className="trading-hero-image">
              <img src="/KM3.jpg" alt="Kenny Miles Exchange Trading" className="trading-image" />
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2 className="section-title">Trading Features</h2>
          <p className="section-subtitle">
            Everything you need for successful cryptocurrency trading in one powerful platform
          </p>
          
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <Coins />
              </div>
              <h3>Real-Time Crypto Trading</h3>
              <p>
                Execute cryptocurrency trades with lightning-fast speed using our advanced order 
                execution system and real-time market data.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <BarChart3 />
              </div>
              <h3>Advanced Charts</h3>
              <p>
                Professional-grade charting tools with over 100 technical indicators 
                and drawing tools for comprehensive crypto market analysis.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <Shield />
              </div>
              <h3>Secure Trading</h3>
              <p>
                Bank-level security with multi-factor authentication, cold storage, 
                and insurance protection for your digital assets.
              </p>
            </div>
            
            <div className="feature-card centered-card">
              <div className="feature-icon">
                <Zap />
              </div>
              <h3>High-Frequency Trading</h3>
              <p>
                Ultra-low latency infrastructure supporting high-frequency trading 
                strategies with millisecond execution times.
              </p>
            </div>
            
            <div className="feature-card centered-card">
              <div className="feature-icon">
                <Globe />
              </div>
              <h3>Global Crypto Markets</h3>
              <p>
                Access to over 100+ cryptocurrencies including Bitcoin, Ethereum, 
                altcoins, and DeFi tokens from global markets.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section bg-light">
        <div className="container">
          <h2 className="section-title">Cryptocurrency Assets</h2>
          <p className="section-subtitle">
            Trade a wide variety of digital assets with competitive fees
          </p>
          
          <div className="instruments-grid">
            <div className="instrument-card">
              <div className="instrument-header">
                <h3>Major Cryptocurrencies</h3>
                <span className="instrument-count">20+ Coins</span>
              </div>
              <p>Trade popular cryptocurrencies with high liquidity and volume.</p>
              <ul>
                <li>Bitcoin (BTC)</li>
                <li>Ethereum (ETH)</li>
                <li>Binance Coin (BNB)</li>
                <li>Cardano (ADA)</li>
                <li>Ripple (XRP)</li>
                <li>Dogecoin (DOGE)</li>
              </ul>
            </div>
            
            <div className="instrument-card">
              <div className="instrument-header">
                <h3>Altcoins</h3>
                <span className="instrument-count">80+ Coins</span>
              </div>
              <p>Access to emerging and established altcoin projects.</p>
              <ul>
                <li>Solana (SOL)</li>
                <li>Polkadot (DOT)</li>
                <li>Chainlink (LINK)</li>
                <li>Polygon (MATIC)</li>
                <li>Litecoin (LTC)</li>
                <li>Stellar (XLM)</li>
              </ul>
            </div>
            
            <div className="instrument-card">
              <div className="instrument-header">
                <h3>DeFi Tokens</h3>
                <span className="instrument-count">50+ Tokens</span>
              </div>
              <p>Trade decentralized finance tokens and governance tokens.</p>
              <ul>
                <li>Uniswap (UNI)</li>
                <li>Aave (AAVE)</li>
                <li>Compound (COMP)</li>
                <li>Yearn Finance (YFI)</li>
                <li>SushiSwap (SUSHI)</li>
                <li>Curve DAO (CRV)</li>
              </ul>
            </div>
            
            <div className="instrument-card">
              <div className="instrument-header">
                <h3>Staking & Yield</h3>
                <span className="instrument-count">30+ Options</span>
              </div>
              <p>Earn passive income through staking and yield farming.</p>
              <ul>
                <li>Proof of Stake</li>
                <li>Liquidity Mining</li>
                <li>Yield Farming</li>
                <li>Validator Rewards</li>
                <li>DeFi Staking</li>
                <li>APY Optimization</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="section cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Start Trading?</h2>
            <p>Join thousands of traders already using Kenny Miles Exchange</p>
            <a 
              href="https://wa.me/2348095732028?text=Hi%20KENNY%20MILES%20EXCHANGE,%20I%20want%20to%20start%20trading" 
              className="btn btn-primary" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              Get Started Today
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Trading;